<template>
    <div v-bind:class="{'q-pa-lg' : $q.screen.gt.sm}"> 

    <q-tabs animated swipeable inverted>

        <q-tab default slot='title' name='tab-1' icon='fas fa-briefcase' label='На складе'/>
        <q-tab slot='title' name='tab-2' icon='fas fa-pencil-ruler' label='Типы материалов'/>
        <q-tab slot='title' name='tab-3' icon='fas fa-truck-pickup' label='Приходы от поставщиков'/>

        <q-tab-pane name='tab-1'>
            <nomenklaturaList/>
        </q-tab-pane>

        <q-tab-pane name='tab-2'>
            
            <div class='lt-lg absolute-center'>
                <div class='q-display-1'>Извините!</div>
                    Раздел не оптимизирован для низкого разрешения.
            </div>

            <div class='gt-md'>
                <div class="param-container row no-wrap">
                    <div style="width:50%"></div>
                    <div style="width:50%; text-align:right">
                        <q-btn label='новый материал' icon="add" color='positive' @click='showEditDialog'/>
                        <!-- <q-btn label='новый приход' color='secondary' icon="fas fa-cart-plus" class='q-ml-lg' @click='showPrihodDialog'/> -->
                    </div>
                
                </div>

                <div class="materials-container">
                    <div v-for="material in materialsList" :key=material.id>
                        <material-line 
                            :material='material'
                        />
                    </div>
                </div>
            </div>

        </q-tab-pane>
        <q-tab-pane name='tab-3'>
                <div class=" row no-wrap justify-end gt-xs">
                       
                       <q-btn class='q-ml-lg q-mb-md' label='Список поставщиков' icon='fas fa-hands-helping' color='secondary' @click='showPostavshikDialog'/>
                       
                       <q-btn label='новый приход' color='positive' icon="fas fa-cart-plus" class='q-ml-lg q-mb-md' @click='showPrihodDialog'/>

                </div>            
            <prihodList/>
        </q-tab-pane>

    </q-tabs>

<!-- Диалоги -->
    <edit-dialog/>
    <prihod-dialog/>
    <correct-dialog/>
    <postavshikDialog/>


    </div>
    
</template>

<script>


/* eslint-disable */
export default {

    name : "materials",

    components : {
        'materialLine': () => import('./materialLine.vue'),
        'editDialog': () =>import('./materialDialog.vue'),
        'prihodDialog' : ()=>import('./prihodDialog.vue'),
        'correctDialog' : ()=>import('./correctDialog.vue'),
        'nomenklaturaList' : ()=>import('./nomenklaturaList.vue'),
        'prihodList' : ()=>import('./prihodList.vue'),
        'postavshikDialog' : ()=>import('./postavshikDialog.vue'),
    },
    
    data () {
            return {
                editMaterialId : -1,
            }
    },

    created() {
        
        // if (this.$store.getters.getAllMaterials.length == 0) { //возможно не загрузили список материалов - загружаем
            this.$store.dispatch('getMaterials');
        // }
        // if (this.$store.getters.getAllPostTypes.length == 0) { // загружаем списко типов постобработки
            this.$store.dispatch("getPostTypes");
        // }
        // if (this.$store.getters.getAllDirections.length == 0) {// загружаем списко направлений деятельности
            this.$store.dispatch('getDirections');
        // }
        // if (this.$store.getters.getNomenklatura.length == 0) {// загружаем всю номенклатуру материалов.
            this.$store.dispatch('getNomenklatura');
        // }
        // if (this.$store.getters.getPostavshiks.length == 0) {// загружаем список поставщиков
            this.$store.dispatch('getAllPostavshiks');
        // }

        // if (this.$store.getters.allUsers.length == 0) {// загружаем список поставщиков
            this.$store.dispatch('retrieveUsers');
        // }



    },

    computed : {
        materialsList() {
            let q = this.$store.getters.getAllMaterials;
            return q.sort( (a,b) => {
                if (a.name > b.name) return  1;
                if (a.name < b.name) return  -1;
                if (a.name == b.name) return  0;
            });
        },
    },

    methods : {
        showPostavshikDialog() {
            eventBus.$emit("showPostavshikDialog");
        },

        showEditDialog() {
            eventBus.$emit("showEditMaterialDialog", this.editMaterialId);
        },
        showPrihodDialog() {
            eventBus.$emit("showPrihodDialog");
        },

    }

}
</script>

<style lang="scss" scoped>
    .param-container {
        
        padding:30px;
    }
    .materials-container {
        padding:10px;
    }
</style>

